(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        window.initSelectize = function() {

            $('[data-plugin=selectize]').each(function () {

                var plugins = ['drag_drop', 'remove_button'];
                if ($(this).hasClass('restore-on-bs')) plugins.push('restore_on_backspace');
                var create = function (input) {
                    return {
                        value: input,
                        text: input
                    };
                };

                if ($(this).hasClass('no-add')) create = false;
                //'restore_on_backspace'
                var $selectItem = $(this).selectize({
                    plugins: plugins,
                    delimiter: ',',
                    persist: false,
                    create: create
                });

                if ($(this).hasClass('selectize-modal')) {

                    $(document).on('savemodal:clear', function (event) {
                        var selectize = $selectItem[0].selectize;
                        selectize.clear();
                    });
                }

                $('#filter').on('filter:clear', function (event) {
                    var selectize = $selectItem[0].selectize;
                    selectize.clear();
                });

                var listen = $(this).attr('data-listen');

                if (listen != undefined) {
                    $(document).on('selectize:'+listen, function (event, item) {
                       // $selectItem[0].selectize.renderCache = {};
                        $selectItem[0].selectize.addOption(item);
                        $selectItem[0].selectize.addItem(item.value);
                    });
                }

            });
        }

        initSelectize();

        var county_id = 0;

        if ($('#filter-county-id-eq').length) {

            county_id = $('#filter-county-id-eq').val();

            $('#filter-county-id-eq').selectize({
                valueField: 'id',
                labelField: 'text',
                searchField: ['text'],

                onChange: function (value) {

                    if (value == undefined) value = 0;
                    county_id = value;
                    city_select.disable();
                    city_select.clearOptions();
                    city_select.trigger('change');

                    city_select.load(function (callback) {
                        xhr && xhr.abort();
                        xhr = $.ajax({
                            url: $('#filter-city-id-eq').attr('data-url') + '?county_id=' + encodeURIComponent(value),
                            success: function (results) {
                                city_select.enable();
                                callback(results.items);
                            },
                            error: function () {
                                callback();
                            }
                        })
                    });
                }
            });
        }


        var xhr, xhr2, xhr3;
        var select_zone, $select_zone,city_select;
        var select_city, select_city, exclude_select_zone, select_streets;
        var havezones = false;
        var havestreets = false;
        var haveexcludedzones = false;

        var selected_city = 0;

        window.initSelectizeCity = function() {

            $('[data-plugin=selectize-cities]').each(function () {

                var url = $(this).attr('data-url');
                var preloadOn = $(this).attr('data-load');

                var preload = false;
                if (preloadOn != undefined) preload = true;
               // console.log(preload);
                var $selectItem = $(this).selectize({
                    valueField: 'id',
                    labelField: 'text',
                    // searchField: 'text',
                    create: false,
                    preload: preload,
                    sortField: [{field: 'sort', direction: 'desc'}, {field: 'name', direction: 'asc'}, {field: '$score'}],

                    load: function (query, callback) {

                         if (!query.length && preload == false) return callback();

                        $.ajax({
                            url: url + '?county_id='+county_id+'&q=' + encodeURIComponent(query),
                            type: 'GET',
                            error: function () {
                                callback();
                            },
                            success: function (res) {

                                callback(res.items);

                            }
                        });
                    },

                    onChange: function (value) {
                            if (value == undefined) value = 0;
                            selected_city = value;
                            if (!havezones) return;
                            select_zone.disable();
                            select_zone.clearOptions();
                            select_zone.load(function (callback) {
                                xhr && xhr.abort();


                                xhr = $.ajax({
                                    url: $('#select-city-zones').attr('data-url') + '?cityid=' + encodeURIComponent(value),
                                    success: function (results) {
                                        select_zone.enable();
                                        callback(results.items);
                                    },
                                    error: function () {
                                        callback();
                                    }
                                });

                                if (value == 13822){//bucharest
                                    $('#select-city-zones').parent().addClass('bucharest');
                                }else{
                                    $('#select-city-zones').parent().removeClass('bucharest');
                                }

                                // if (value == 19026){//international
                                //     //console.log('selected international');
                                //     $('#international-wrapper').parent().addClass('shouldshow');
                                // }else{
                                //     $('#international-wrapper').parent().removeClass('shouldshow');
                                // }

                            });

                        if (haveexcludedzones){
                            exclude_select_zone.disable();
                            exclude_select_zone.clearOptions();
                            exclude_select_zone.load(function (callback) {
                                xhr2 && xhr2.abort();
                                xhr2 = $.ajax({
                                    url: $('#select-city-zones').attr('data-url') + '?cityid=' + encodeURIComponent(value),
                                    success: function (results) {
                                        exclude_select_zone.enable();
                                        callback(results.items);
                                    },
                                    error: function () {
                                        callback();
                                    }
                                })
                            });
                        }

                        if (havestreets){
                            select_streets.disable();
                            select_streets.clearOptions();
                            select_streets.load(function (callback) {
                                xhr3 && xhr3.abort();
                                xhr3 = $.ajax({
                                    url: $('#select-streets').attr('data-url') + '?cityid=' + encodeURIComponent(value),
                                    success: function (results) {
                                        select_streets.enable();
                                        callback(results.items);
                                    },
                                    error: function () {
                                        callback();
                                    }
                                })
                            });
                        }

                    }

                });



            });
        }

        initSelectizeCity();

        if ($('#filter-city-id-eq').length){
            var $city = $('#filter-city-id-eq');
            city_select = $city[0].selectize;
            window.city_select = city_select;
        }

        window.initSelectizeZones = function() {
            if ($('#select-city-zones').length) {
                havezones = true;
                $select_zone = $('#select-city-zones').selectize({
                    valueField: 'id',
                    labelField: 'text',
                    searchField: ['text'],
                    plugins: ['remove_button'],

                    onChange: function (value) {
                        if (havestreets){
                            var $city = $('#city-id');
                            city_select = $city[0].selectize;
                            selected_city = city_select.getValue();

                            select_streets.disable();
                            select_streets.clearOptions();
                            select_streets.load(function (callback) {
                                xhr3 && xhr3.abort();
                                xhr3 = $.ajax({
                                    url: $('#select-streets').attr('data-url') + '?cityid=' + encodeURIComponent(selected_city)+'&zoneid='+encodeURIComponent(value),
                                    success: function (results) {
                                        select_streets.enable();
                                        callback(results.items);
                                    },
                                    error: function () {
                                        callback();
                                    }
                                })
                            });
                        }
                    }

                });

                select_zone = $select_zone[0].selectize;
                window.select_city_zones = select_zone;
            }

            if ($('#excluded-city-zones').length) {
                haveexcludedzones = true;
                $select_zone = $('#excluded-city-zones').selectize({
                    valueField: 'id',
                    labelField: 'text',
                    searchField: ['text'],
                    plugins: ['remove_button'],
                });

                exclude_select_zone = $select_zone[0].selectize;
                window.excluded_city_zones = exclude_select_zone;
            }

            if ($('#select-streets').length) {
                havestreets = true;

               var $select_street = $('#select-streets').selectize({
                    valueField: 'id',
                    labelField: 'name',
                    searchField: ['name'],
                    plugins: ['remove_button'],

                   onChange: function (value) {
                       if (!value.length) return;
                      if ($('#address').length)$('#address').val($("#select-streets option:selected").text()) ;

                   }
                });

                select_streets = $select_street[0].selectize;

                $(document).on('selectizeajax:addstreet', function (event, item) {
                    select_streets.addOption(item);
                    select_streets.addItem(item.id);
                });
            }

        };

        initSelectizeZones();


        window.initSelectizeAjax = function() {


            $('[data-plugin=selectizeajax]').each(function () {

                var url = $(this).attr('data-url');


                var $selectItem = $(this).selectize({
                    plugins: ['remove_button'],
                    valueField: 'id',
                    labelField: 'name',
                    searchField: ['name','emails','phones'],
                    create: false,

                    render: {
                        option: function (item, escape) {
                            if (item.html != undefined) return '<div>'+item.html+'</div>';

                            var email = '';
                            if (item.emails != '' && item.emails != undefined) {
                                email = '<span class="email"><i class="ti-email"></i> ' + item.emails + '</span>';
                            }

                            var phone = '';
                            if (item.phones != '' && item.phones != undefined) {
                                phone = '<span class="phone"><i class="fa-phone"></i> ' + item.phones + '</span>';
                            }


                            return '<div class="autosuggest-box">' +
                                '<span class="name">' + escape(item.name) + '</span>' +
                                '<span class="autosuggest-box-info">' +
                                email +
                                phone +
                                '</span>' +
                                '</div>';
                        }
                    },


                    load: function (query, callback) {

                        if (!query.length) return callback();
                        var queryOld = query;
                        query = query.replace(/[,.+/]/g,'');
                        if (query.startsWith('004')) query = query.substring(3);
                        if (query.startsWith('00'))query = query.substring(2);
                        if (query.startsWith('40'))query = query.substring(1);


                        if (query!=queryOld) this.setTextboxValue(query);

                        $.ajax({
                            url: url + '?q=' + encodeURIComponent(query),
                            type: 'GET',
                            error: function () {
                                callback();
                            },
                            success: function (res) {

                                callback(res.items);

                            }
                        });
                    }
                });

                var listen = $(this).attr('data-listen');

                if (listen != undefined) {
                    $(document).on('selectizeajax:'+listen, function (event, item) {
                        $selectItem[0].selectize.renderCache = {};
                        $selectItem[0].selectize.addOption(item);
                        $selectItem[0].selectize.addItem(item.id);
                    });

                    $(document).on('selectizeajax:edit'+listen, function (event, item) {

                        if ( parseInt($selectItem[0].selectize.getValue()) == parseInt(item.id)) {

                            $selectItem[0].selectize.removeItem(item.id);
                            $selectItem[0].selectize.clearOptions();
                            $selectItem[0].selectize.renderCache = {};
                            $selectItem[0].selectize.addOption(item);
                            $selectItem[0].selectize.addItem(item.id);
                        }
                    });
                }

            });
        }

        initSelectizeAjax();

        $(document).on('change', '[data-type="contactselect"]', function () {
            var id = $(this).val();
            var group = $(this).parent().find('.input-group-btn');
            if (id){
               // console.log(id);
                var route = $(this).data('info');
                if (route != undefined) {
                    route = route.replace('xxx', id);
                    var btn = group.find('.contact-show-info').first();
                    if (btn) btn.attr('data-url', route);
                    var clone = btn.clone();
                    btn.replaceWith(clone);
                    group.addClass('with-show');
                }
            }else{
                group.removeClass('with-show');
            }


        })


    });




})(document, window, jQuery);
